import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
    theme: {
        primary: '#003b46',
        secondary: '#07575b',
        accent: '#ff9800',
        info: '#66a5ad',
        error: '#F4511E'
    }
})
